import { useState, useEffect } from "react";
import WizardNavigation from "../WizardNavigation";
import StepHeader from "../StepHeader";

const EVENT_TYPES = [
  { value: "wedding", label: "Hochzeit" },
  { value: "birthday", label: "Geburtstag" },
  { value: "corporate", label: "Firmenevent" },
  { value: "anniversary", label: "Jubiläum" },
  { value: "other", label: "Sonstiges" },
];

export default function StepEventType({ value, onNext, onBack }) {
  const [selectedValue, setSelectedValue] = useState(value || "");
  const [showCustomInput, setShowCustomInput] = useState(false);
  const [customEventType, setCustomEventType] = useState("");

  // Synchronisiere State mit value Prop (wichtig beim Zurückgehen)
  useEffect(() => {
    const isPredefinedEvent = EVENT_TYPES.find((e) => e.value === value);

    if (value && !isPredefinedEvent) {
      // Custom event - Input anzeigen und mit Wert füllen
      setShowCustomInput(true);
      setCustomEventType(value);
      setSelectedValue("");
    } else if (value === "other") {
      // "Sonstiges" ausgewählt, aber noch kein Custom-Text eingegeben
      setShowCustomInput(true);
      setCustomEventType("");
      setSelectedValue("other");
    } else if (value) {
      // Vordefinierter Event ausgewählt
      setShowCustomInput(false);
      setCustomEventType("");
      setSelectedValue(value);
    } else {
      // value ist null - zurücksetzen
      setShowCustomInput(false);
      setCustomEventType("");
      setSelectedValue("");
    }
  }, [value]);

  const handleSelect = (eventType) => {
    if (eventType === "other") {
      // "Sonstiges" ausgewählt - Input-Feld anzeigen
      setShowCustomInput(true);
      setSelectedValue("other");
    } else {
      // Vordefinierter Typ - nur Auswahl setzen
      setShowCustomInput(false);
      setCustomEventType("");
      setSelectedValue(eventType);
    }
  };

  const handleNext = () => {
    if (showCustomInput && customEventType.trim()) {
      // Custom Event eingegeben
      onNext({ eventType: customEventType.trim() });
    } else if (selectedValue) {
      // Vordefinierter Typ ausgewählt
      onNext({ eventType: selectedValue });
    }
  };

  return (
    <div className="space-y-6">
      <StepHeader
        title="Für welches Event suchst du eine Fotobox?"
        description="Das hilft uns, dir die beste Empfehlung zu geben."
      />

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
        {EVENT_TYPES.map((event) => (
          <button
            key={event.value}
            onClick={() => handleSelect(event.value)}
            className={`p-4 rounded-lg border-2 transition font-medium ${
              event.value === "other"
                ? showCustomInput
                  ? "border-[#FF5744] bg-[#FFF4F0] text-slate-900"
                  : "border-slate-200 bg-white text-slate-700 hover:border-slate-300"
                : selectedValue === event.value
                ? "border-[#FF5744] bg-[#FFF4F0] text-slate-900"
                : "border-slate-200 bg-white text-slate-700 hover:border-slate-300"
            }`}
          >
            {event.label}
          </button>
        ))}
      </div>

      {showCustomInput && (
        <div className="space-y-3">
          <label className="block text-sm font-medium text-slate-700">
            Dein Event-Typ:
          </label>
          <input
            type="text"
            value={customEventType}
            onChange={(e) => setCustomEventType(e.target.value)}
            placeholder="z.B. Schulabschluss, Jubiläum, etc."
            className="w-full px-4 py-2 border-2 border-slate-200 rounded-lg focus:outline-none focus:border-[#FF5744]"
            autoFocus
          />
        </div>
      )}

      <WizardNavigation
        onBack={onBack}
        onNext={handleNext}
        disableNext={showCustomInput ? !customEventType.trim() : !selectedValue}
        hideBack={true}
      />
    </div>
  );
}
